export default `
  /** Font-face delarations go here **/
  @import url('https://fonts.googleapis.com/css?family=Arapey|Montserrat');
`



// WEBPACK FOOTER //
// ./src/ui/styles/fonts.js